import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    data() {
        return {
            downloadLoading: false,
        }
    },
    computed: {
        // 默认最新采购规范(LATEST_SPEC = 2);PDS 等页面按需覆盖为 1
        $_drawingDownloadScope() {
            return 2;
        },
    },
    methods: {
        downloadDrawing(id, fileName) {
            if (this.downloadLoading) {
                this.$message.warning("请等待上一个下载完成");
                return;
            }
            this.downloadLoading = true;
            this.$message.info("下载中...")
            let url = process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/download/one?drawingId=" + id;
            this.downloadWithHeader(url, fileName, () => this.downloadLoading = false);
        },
        batchDownloadDrawing(idList, material) {
            if (this.downloadLoading) {
                this.$message.warning("请等待上一个下载完成");
                return;
            }
            let fileName = '';
            let length = idList.length;
            if (length > 0) {
                fileName += material;
            } else {
                return;
            }
            if (length > 1) {
                fileName += '...';
            }
            fileName += '(共' + length + '个文件).zip'
            this.downloadLoading = true;
            this.$message.info("下载中...");
            let url = process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/download/batch?drawingIds=" + idList.join(',');
            this.downloadWithHeader(url, fileName, () => this.downloadLoading = false);
        },

        batchDownloadBomDrawing(materialList) {
            if (materialList && materialList.length > 0) {
                this.$store.dispatch("drawingDownload/open", {
                    materials: materialList,
                    scope: this.$_drawingDownloadScope,
                    module: this.$options.name || "",
                });
            } else {
                this.$message.warning("没有选中的有效物料号");
            }
        },
    }
}
